import * as attributionReportsActions from './attributionReports';
import * as reportsActions from './reports';

export default {
  ...attributionReportsActions,
  ...reportsActions,
};
